import {
  ACTIVE_MENU,
  CITY_LIST,
  DISTRICT_LIST,
  DIVISION_LIST,
  PRIVACY_POLICY,
  STATE_LIST,
  TERMS_CONDITION,
} from "./types";

export const fetchStateList = (onSuccess, onError) => {
  return {
    type: STATE_LIST,
    onSuccess,
    onError,
  };
};

export const fetchDistrictList = (state_id, onSuccess, onError) => {
  return {
    type: DISTRICT_LIST,
    state_id,
    onSuccess,
    onError,
  };
};

export const fetchCityList = (state_id, district_id, onSuccess, onError) => {
  return {
    type: CITY_LIST,
    state_id,
    district_id,
    onSuccess,
    onError,
  };
};

export const fetchDivisionList = (onSuccess, onError) => {
  return {
    type: DIVISION_LIST,
    onSuccess,
    onError,
  };
};

export const activeMenu = (index, onSuccess, onError) => {
  return {
    type: ACTIVE_MENU,
    index,
    onSuccess,
    onError,
  };
};
export const privacyPolicy = (onSuccess, onError) => {
  return {
    type: PRIVACY_POLICY,
    onSuccess,
    onError,
  };
};
export const termsCondition = (onSuccess, onError) => {
  return {
    type: TERMS_CONDITION,
    onSuccess,
    onError,
  };
};
